"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            certificates: null,
            categories: [
                {
                    name: 'Course',
                    active: true
                },
                { name: 'Program' },
                { name: 'Department' },
                { name: 'Enrollment' },
                { name: 'Issued' }
            ],
            type: 'course',
            activeSection: null,
            activeSectionIndex: null
        };
        GState.bind(this, ['screen']);
    },
    onMount: function () {
        this.fetchCertificates(this.state.type);
    },
    fetchCertificates: async function (type) {
        try {
            type = type.toLowerCase();
            const {error, message, results} = await Request(`/${ type }/list`);
            if (error)
                console.log(`Error Fetching Certificates of <${ type }>: `, message);
            const list = {};
            results.map(entity => {
                const {name, description, poster, courseId, programId, enrollmentId, certificates} = entity;
                (certificates || []).map(each => {
                    if (!list.hasOwnProperty(each.reference))
                        list[each.reference] = {
                            ...each,
                            assignList: {}
                        };
                    const entityId = courseId || programId || enrollmentId;
                    if (list[each.reference].assignList.hasOwnProperty(entityId))
                        return;
                    list[each.reference].assignList[entityId] = {
                        name,
                        description,
                        poster
                    };
                });
            });
            this.setState({
                type,
                certificates: list,
                activeSection: null,
                activeSectionIndex: null
            });
        } catch (error) {
            console.log('Error Fetching Certificates: ', error);
            this.state.certificates = null;
        }
    },
    openCertificate: function (reference, sIndex) {
        this.setState({
            activeSectionIndex: sIndex,
            activeSection: this.state.certificates[reference].assignList
        });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Rewards/Certificates.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    FilterButton_template = require("../../components/FilterButton.marko"),
    FilterButton_tag = marko_loadTag(FilterButton_template),
    DoSearch_template = require("../../../components/DoSearch/index.marko"),
    DoSearch_tag = marko_loadTag(DoSearch_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "col-12 mod-section theme-bg-fade p-2 my-2 rounded"
      },
    marko_attrs1 = {
        "class": "col-lg-3 col-sm-4"
      },
    marko_attrs2 = {
        "class": "col-lg-9 col-sm-8"
      },
    marko_attrs3 = {
        "class": "card-body"
      },
    marko_attrs4 = {
        "class": "card-text overflow-hidden font-medium-2"
      },
    marko_attrs5 = {
        "class": "font-small-3 text-muted text-ellipsis mb-0"
      },
    marko_attrs6 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("f8d517"),
    marko_node0 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "btn btn-primary btn-lg m-25"
      },
    marko_attrs9 = {
        "class": "btn btn-secondary btn-lg m-25"
      },
    marko_node3 = marko_createElement("img", {
        src: "/images/illustration/create-certificate.webp",
        "class": "img-fluid",
        alt: "illustration"
      }, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "filters"
      },
    marko_node4 = marko_createElement("br", null, "34", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        id: "certificates-list",
        "class": "mt-2"
      },
    marko_attrs12 = {
        "class": "col"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_ModularSection(out) {
    out.be("div", marko_attrs0, "0", component);

    Row_tag(marko_mergeNestedTagsHelper({
        class: "m-0",
        renderBody: function(out, $nestedTagRow$0) {
          var $for$0 = 0;

          marko_forIn(state.activeSection, function(id, { poster, name, description }) {
            var $keyScope$0 = "[" + (($for$0++) + "]");

            Row_col_nested_tag({
                ns: "col-md-4 col-6",
                qs: "col-md-4 col-12",
                hs: "col-6",
                class: "animated fadeIn fast",
                renderBody: function(out) {
                  route_link_tag({
                      href: (("/" + state.type) + "/") + id,
                      class: "d-block",
                      renderBody: function(out) {
                        Row_tag({
                            class: "no-gutters",
                            renderBody: function(out) {
                              out.be("div", marko_attrs1, "5" + $keyScope$0, component);

                              Image_tag({
                                  alt: name,
                                  src: poster,
                                  class: "h-100 w-100 rounded"
                                }, out, __component, "6" + $keyScope$0);

                              out.ee();

                              out.e("div", marko_attrs2, "7" + $keyScope$0, component, 1)
                                .e("div", marko_attrs3, "8" + $keyScope$0, component, 2)
                                  .e("div", marko_attrs4, "9" + $keyScope$0, component, 1)
                                    .t(name, component)
                                  .e("p", marko_attrs5, "10" + $keyScope$0, component, 1)
                                    .t(description, component);
                            }
                          }, out, __component, "4" + $keyScope$0);
                      }
                    }, out, __component, "3" + $keyScope$0);
                }
              }, $nestedTagRow$0);
          });
        }
      }), out, __component, "1");

    out.ee();
  }

  Wrapper_Admin_tag({
      renderBody: function(out, { page, themeMode }) {
        if (state.certificates == null) {
          LoadingPage_tag({}, out, __component, "12");
        } else if (isEmpty(state.certificates)) {
          out.be("div", marko_attrs6, "13", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("h5", null, "16", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Create, Manage and Issue certificates");
                          }
                        }, out, __component, "17");

                      out.ee();

                      out.n(marko_node0, component);

                      out.be("p", marko_attrs7, "19", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Start with the creation of your institution's attractive certificate using our well thought tools. Explore available");
                          }
                        }, out, __component, "20");

                      out.t(" ");

                      route_link_tag({
                          href: "/templates/certificates",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Certificate Templates"
                              }, out, __component, "22");
                          }
                        }, out, __component, "21");

                      out.t(" ");

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("designed to make your life easier and to inspire you to be able to create your own.");
                          }
                        }, out, __component, "23");

                      out.ee();

                      out.n(marko_node1, component);

                      out.n(marko_node2, component);

                      out.be("button", marko_attrs8, "26", component, null, 0, {
                          onclick: __component.d("click", () => window.Extensions.run( 'XCredible', { action: 'create' } ), false)
                        });

                      Locale_tag({
                          text: "Create certificate"
                        }, out, __component, "27");

                      out.ee();

                      out.be("button", marko_attrs9, "28", component, null, 0, {
                          onclick: __component.d("click", () => window.Extensions.run('XCredible', { action: 'open:templates' }), false)
                        });

                      Locale_tag({
                          text: "See templates"
                        }, out, __component, "29");

                      out.ee();
                    }
                  }, out, __component, "15");

                WSAdapt_tag({
                    class: "col text-center",
                    renderBody: function(out) {
                      out.n(marko_node3, component);
                    }
                  }, out, __component, "30");
              }
            }, out, __component, "14");

          out.ee();
        } else {
          out.be("section", marko_attrs10, "32", component);

          Row_tag({
              class: "m-0 p-50",
              renderBody: function(out) {
                marko_forOf(state.categories, function({ name, active }, index) {
                  FilterButton_tag({
                      label: name,
                      active: active
                    }, out, __component, index, [
                    [
                      "change",
                      status => component.fetchCertificates( name ),
                      false
                    ]
                  ]);
                });
              }
            }, out, __component, "33");

          out.n(marko_node4, component);

          Row_tag({
              class: "m-0 icons d-flex align-items-center mx-1",
              renderBody: function(out) {
                out.be("div", marko_attrs12, "36", component);

                DoSearch_tag({
                    target: "certificates"
                  }, out, __component, "37");

                out.ee();
              }
            }, out, __component, "35");

          out.ee();

          out.be("section", marko_attrs11, "38", component);

          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                const sectionAnchor = state.screen.media == 'ns' ? 4 : state.screen.media == 'qs' ? 3 : 2

                let counter = 0

                let sectionIndex = 0

                var $for$1 = 0;

                marko_forIn(state.certificates, function(reference, { poster }) {
                  counter++

                  var $keyScope$1 = "[" + (($for$1++) + "]");

                  WSAdapt_tag({
                      ns: "col-md-3 col-6",
                      qs: "col-4",
                      hs: "col-6",
                      renderBody: function(out) {
                        out.be("div", {
                            "class": "card cursor-pointer",
                            title: reference
                          }, "41" + $keyScope$1, component, null, 0, {
                            onclick: __component.d("click", "openCertificate", false, [
                                reference,
                                sectionIndex + sectionAnchor
                              ])
                          });

                        Image_tag({
                            alt: reference,
                            src: poster,
                            class: "img-fluid w-100 rounded",
                            icon: "bx bx-medal bx-lg",
                            style: "min-height:12rem"
                          }, out, __component, "42" + $keyScope$1);

                        out.ee();
                      }
                    }, out, __component, "40" + $keyScope$1);

                  if (((counter % sectionAnchor) == 0) && (state.activeSectionIndex == counter)) {
                    sectionIndex = counter

                    marko_dynamicTag(out, macro_ModularSection, null, null, null, null, __component, "43" + $keyScope$1);
                  }
                });

                if ((Object.keys(state.certificates).length > sectionIndex) && (state.activeSectionIndex == (sectionIndex + sectionAnchor))) {
                  marko_dynamicTag(out, macro_ModularSection, null, null, null, null, __component, "44");
                }
              }
            }, out, __component, "39");

          out.ee();
        }
      }
    }, out, __component, "11");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
